/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { useRef, useCallback, MouseEventHandler } from "react";
import { useTimeoutFn } from "react-use";

/**
 * Disable click events when a short continuous click event occurs.
 * @param {MouseEventHandler<HTMLButtonElement>} onClick
 * @return {MouseEventHandler<HTMLButtonElement>}
 */
export const useClickHandler = (
  onClick?: MouseEventHandler<HTMLButtonElement>
) => {
  const clicked = useRef(false);
  const tmFn = useTimeoutFn(() => {
    clicked.current = false;
  }, 500);
  const reset = tmFn[2];
  return useCallback<MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      if (clicked.current) {
        return;
      }
      clicked.current = true;
      reset();
      onClick?.(event);
    },
    [onClick, reset]
  );
};
